/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { PublicScenarioSummaryDisplayType } from './publicScenarioSummaryDisplayType'

export interface PublicScenarioSummary {
  updatedAt: string
  /** @nullable */
  publishedAt: string | null
  displayType: PublicScenarioSummaryDisplayType
  name: string
  id: Cuid
}
